const link = document.querySelector('.tool-anchor');
const tabPanel = document.querySelector('.tab-tools');

if (link) {
    link.addEventListener('click', () => {
        tabPanel.click();
    });
}
